import { Ptag } from 'components/core/fonts'
import { startCase, toLower } from 'lodash'
import styled from 'styled-components'
import { colors } from 'theme'

function SummaryBox({ field, value, showFullWidth=false }) {

    const flexWidth = {flex: "0 0 16.5rem"}
    const fullWidth = {width: "100%"}

    return (
        <Box style={showFullWidth ? fullWidth : flexWidth}>
            <div>
            {/* <Ptag fontSize='16px' fontWeight='500' color='#655F77' maxwidth="60%" textTransform="capitalize">Claim</Ptag> */}
            <Ptag fontSize='16px' fontWeight='500' color='#655F77' maxwidth="100%" textTransform="capitalize">{startCase(toLower(field))}</Ptag>
            </div>
            <Ptag fontSize='44px' fontWeight='600' marginTop="20px">{value}</Ptag>
        </Box>
    )
}

export default SummaryBox

const Box = styled.div`
  display: flex;
  flex-basis: 20rem;
  flex-direction: column;
  justify-content: space-between;
  padding: 18px;
  border: 1px solid #A9A4AE; 
  border-radius: 8px
`